<template>
  <div>
  <v-tabs icons-and-text centered color='primary'>
      <v-tab
        v-for='(tab,i) in selectedProject.tabs'
        :key='tab.key'
        :to='tab.routeName'>
        {{tab.name}}
        <v-icon>{{tab.icon}}</v-icon>
      </v-tab>
      <v-tab-item
        v-for="tab in selectedProject.tabs"
        :key="tab.routeName"
      >
        <v-card flat>
          <v-card-text>{{ tab.routeName }}</v-card-text>
        </v-card>
      </v-tab-item>
          </v-tabs>
          <router-view> </router-view>
      </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('project', {
      projects: 'projects',
      selectedProject: 'selectedProject'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectMain.vue